import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home, Compass } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function NotFound() {
  const { t } = useLang();
  useEffect(() => {
    const prev = document.title;
    document.title = `${t("not_found_title")} · ANGOLAUK+`;
    return () => { document.title = prev; };
  }, [t]);
  return (
    <div className="page fade-up" data-testid="not-found-page">
      <div className="min-h-[60vh] flex flex-col items-start justify-center py-12 max-w-md">
        <div className="font-display text-7xl font-extrabold text-[#c8102e] leading-none" aria-hidden="true">404</div>
        <h1 data-testid="not-found-title" className="font-display text-2xl font-extrabold mt-4">{t("not_found_title")}</h1>
        <p className="text-sm text-zinc-500 mt-2">{t("not_found_body")}</p>
        <div className="flex flex-wrap gap-3 mt-8">
          <Link to="/" data-testid="not-found-home-btn"
                className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-black text-white text-sm font-semibold hover:bg-zinc-800 transition-colors">
            <Home size={16} /> {t("back_home")}
          </Link>
          <Link to="/explorar" data-testid="not-found-explore-btn"
                className="inline-flex items-center gap-2 px-5 py-3 rounded-full border border-zinc-300 bg-white text-sm font-semibold hover:border-black transition-colors">
            <Compass size={16} /> {t("go_explore")}
          </Link>
        </div>
      </div>
    </div>
  );
}
